import { View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { getAttributeLabel } from '../../../../../../../utils/productParameters';
import { Detail } from '../../../DetailsPage/Details';

function ComponentDescription({ productSnapshot, productCategory, i18n, productLabels }) {
  const {
    width,
    componentSize,
    composition,
    zipperType,
    grammage,
    producerCode,
    underSliderType,
    upperSliderType,
    yardage,
    supplierShortName,
    supplierFullName,
  } = productSnapshot;

  const supplier = supplierFullName || supplierShortName;

  return (
    <View style={{ display: 'flex', flexDirection: 'column' }}>
      {productCategory?.hasSupplier && !!supplier && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'supplier', productCategory.type)}
          description={supplier || '-'}
        />
      )}
      {productCategory?.hasProducerCode && !!producerCode && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'producerCode', productCategory.type)}
          description={producerCode || '-'}
        />
      )}
      {productCategory?.hasWidth && !!width && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'width', productCategory.type)}
          description={width || '-'}
        />
      )}
      {productCategory?.hasComponentSize && !!componentSize && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'componentSize', productCategory.type)}
          description={componentSize || '-'}
        />
      )}
      {productCategory?.hasComposition && !!composition && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'composition', productCategory.type)}
          description={composition || '-'}
        />
      )}
      {productCategory?.hasGrammage && !!grammage && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'grammage', productCategory.type)}
          description={grammage || '-'}
        />
      )}
      {productCategory?.hasZipperType && !!zipperType && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'zipperType', productCategory.type)}
          description={zipperType || '-'}
        />
      )}
      {productCategory?.hasUpperSliderType && !!upperSliderType && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'upperSliderType', productCategory.type)}
          description={upperSliderType || '-'}
        />
      )}
      {productCategory?.hasUnderSliderType && !!underSliderType && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'underSliderType', productCategory.type)}
          description={underSliderType || '-'}
        />
      )}
      {productCategory?.hasYardage && !!yardage && (
        <Detail
          title={getAttributeLabel(i18n, productLabels, 'yardage', productCategory.type)}
          description={yardage || '-'}
        />
      )}
    </View>
  );
}

export default withTranslation('specification')(ComponentDescription);
